module.exports = __webpack_public_path__ + "static/back-612c47bd6c3077cf2048d62f93ea4832.jpg";